import { Directive, ElementRef, HostListener, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appAutoResize]'
})
export class AutoResizeDirective implements AfterViewInit {

  private minWidth = 50;  // Minimum width in pixels
  private padding = 0;    // Extra space to avoid text cutoff

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    setTimeout(() => this.adjustWidth());
  }

  @HostListener('input') onInput() {
    this.adjustWidth();
  }

  private adjustWidth() {
    let input = this.el.nativeElement.querySelector('input');
    if (!input) {
      input = this.el.nativeElement as HTMLInputElement;
      this.padding = 25;
    }
    if (!input) return;

    // Create a hidden span to measure text width
    const tempSpan = this.renderer.createElement('span');
    this.renderer.setStyle(tempSpan, 'position', 'absolute');
    this.renderer.setStyle(tempSpan, 'visibility', 'hidden');
    this.renderer.setStyle(tempSpan, 'white-space', 'nowrap');
    this.renderer.setProperty(tempSpan, 'innerText', input.value || input.placeholder || 'W');
    this.renderer.appendChild(document.body, tempSpan);

    const newWidth = tempSpan.offsetWidth + this.padding;
    this.renderer.removeChild(document.body, tempSpan);

    // Set the width dynamically with a minimum limit
    this.renderer.setStyle(input, 'width', `${Math.max(this.minWidth, newWidth)}px`);
  }
}
